import React from "react";
import { Stack } from "@mui/material";

import CommentItem from "./CommentItem";

const CommentThread = ({
  comment,
  currentUserId,
  users,
  onReply,
  onEdit,
  onDelete,
  onReaction,
}) => {
  return (
    <Stack gap="8px" px="6px">
      <CommentItem
        comment={comment}
        currentUserId={currentUserId}
        users={users}
        onReply={onReply}
        onEdit={onEdit}
        onDelete={onDelete}
        onReaction={onReaction}
      />
      {comment.replies?.length > 0 && (
        <Stack
          pl="20px"
          gap="10px"
          sx={(theme) => ({
            borderLeft: `2px solid ${theme.palette.hubColors.greyLight}`,
            ml: "12px",
          })}
        >
          {comment.replies.map((reply) => (
            <CommentItem
              key={reply.id}
              comment={reply}
              currentUserId={currentUserId}
              users={users}
              onReply={onReply}
              onEdit={onEdit}
              onDelete={onDelete}
              onReaction={onReaction}
              hideReply
            />
          ))}
        </Stack>
      )}
    </Stack>
  );
};

export default CommentThread;
